export default __webpack_public_path__ + "static/media/jester_black.d3196538.svg";